import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/business/Footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import { Helmet } from 'react-helmet-async';

const NotFoundPage = () => {
    return (
        <div className="not-found-page">
            <Header />
            <main className="page_content not-found-content">
                <section className="not-found-section section_space">
                    <div className="container text-center">
                        <h1 className="display-1">404</h1>
                        <h2>Oops! Deze pagina kon niet worden gevonden.</h2>
                        <p>
                            De pagina die je zoekt bestaat niet. Mogelijk heb je een onjuiste URL
                            ingevoerd of de pagina is verplaatst.
                        </p>
                        <Link to="/" className="btn">
                            <span className="btn_label" data-text="Terug naar Home">Terug naar Home</span>
                            <span className="btn_icon">
                                <i className="fa-solid fa-arrow-up-right"></i>
                            </span>
                        </Link>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </div>
    );
};

export default NotFoundPage;
